/*
 * Copyright (c) 2014-2023 Comparatio
 */

import {Injectable} from '@angular/core';
import {Page} from '../model/page';
import {GeneralService} from './general.service';
import {HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { IZeroOutInventory } from '../views/zero-out-inventory/interfaces/IZeroOutInventory';
import * as _ from 'lodash';

@Injectable()
export class ZeroOutInventoryService extends GeneralService {

  constructor(
      protected http : HttpClient
  ) {
    super ( http );
  }
  public getDataList ( page : Page ) : Observable<any> {
    const url = '/zero-out-inventory/index';
    return this.getRestList ( page, url );
  }

  public delete ( ZO1_ID: number ) : Observable<any> {
	const url = `${this.apiUrl}/zero-out-inventory/delete`;
	return this.http.post(url, {ZO1_ID: ZO1_ID});
  }
  
  public deleteMultiple(ZO1_IDs: Array<number>): Observable<any> {
	const url = `${this.apiUrl}/zero-out-inventory/delete-multiple`;
	return this.http.post(url, {ZO1_IDs: ZO1_IDs});
  }

  public initialize () {
	  return {
		  ZO1_ID : null,
		  CO1_ID: null,
		  COMPANY_NAME : null,
		  ZO1_BRANCH : null,
		  CU1_ID : null,
		  CUSTOMER_NAME : null,
		  ZO1_ITEM : null,
		  ZO1_RESTRICT_INVENTORY_FIXED : null,
		  ZO1_DISPLAY_INVENTORY_FIXED : null,
		  ZO1_DISPLAY_FIXED_QUANTITY : null,
		  ZO1_START_DATE : null,
		  ZO1_END_DATE : null,
		  ZO1_CREATED_ON : null,
		  ZO1_CREATED_BY : null,
		  ZO1_MODIFIED_ON : null,
		  ZO1_MODIFIED_BY : null,
		  ZO1_DELETE_FLAG : null
	  };
  }
	
	public create(zoi: IZeroOutInventory): Observable<any> {
        return this.http.post(this.apiUrl + '/zero-out-inventory/create', zoi)
            .do(data => console.log('createZeroOutInventory: ' + JSON.stringify(data)))
            .catch(this.handleError);
	}
	
	public update(zoi: IZeroOutInventory): Observable<any> {
        return this.http.put(this.apiUrl + '/zero-out-inventory/update', zoi)
            .catch(this.handleError);
	}

	public getById(id): Observable<any> {
		if (_.isEmpty(id)) {
			return Observable.of(this.initialize());
		}
		
		const url = `${this.apiUrl}/zero-out-inventory/view`;
		return this.http.get(url, {params: {ZO1_ID: id}});
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/services/zero-out-inventory.service.ts